<template>
    <div>
        <div v-if="value" class="back-drop"></div>
        <div v-if="value" class="back-drop-modal" style="display: inline-block" @click="modalBackDrop">
            <div class="alert-parent">
                <div class="alert-modal" :style="(width ? 'width:' + width + 'px;' : '') + (padding ? 'padding:' + padding + 'px;' : '')">
                    <button @click="$emit('input', false)" class="alert__close">
                        ×
                    </button>
                    <div class="alert__left-body  alert__body--space-top">
                        <div v-if="modalTitle" class="alert__header  justify-content-start">
                            <h3 class="alert__title">{{ modalTitle }}<small class="section__descr" v-if="modalDescription"><br/>{{ modalDescription }}</small></h3>
                        </div>
                        <div>
                            <slot></slot>
                        </div>

                        <div v-if="cancelButtonLabel || okButtonLabel" class="alert__actions">
                            <button v-if="cancelButtonLabel" @click="$emit('input', false)" type="button" class="btn  btn--info-outline">{{ cancelButtonLabel }}</button>
                            <button v-if="okButtonLabel" @click="$emit('ok-button-click');$emit('okButtonClick')" type="button" class="btn  btn--info">{{ okButtonLabel }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CustomModal',
  props: {
    value: Boolean,
    modalTitle: String,
    modalDescription: String,
    cancelButtonLabel: String,
    okButtonLabel: String,
    animation: {
      type: [String, Object],
      default: () => ({
        classes: 'zoomIn',
        duration: 200
      })
    },
    width: [Number, String],
    padding: [Number, String],
    backClose: Boolean
  },
  methods: {
    modalBackDrop (e) {
      if (this.backClose && e.target.classList.contains('back-drop-modal')) {
        this.$emit('input', false)
      }
    }
  }
}
</script>

<style scoped>
    .alert-modal {
        background-color: #ffffff;
        border-radius: 5px;
        position: relative;
        margin-bottom: 50px;
    }

    .alert-parent {
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
        padding:50px;
    }

    .back-drop {
        background-color: rgba(0,0,0,.5);
        position: fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        z-index: 1050;
    }
    .back-drop-modal {
        z-index: 1050;
        position: fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        min-height: 100%;
        overflow: auto;
    }

    .alert__close {
        position: absolute;
        right: 20px;
        top: 0;
        font-size: 40px;
    }
</style>
